import { Auth } from 'aws-amplify';

const signIn = async (email, password) => {
  try {
    const response = await Auth.signIn(email, password);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

const signUp = async (
  username,
  password,
  fullName,
  userType,
  agreedToTerms,
) => {
  const attributes = {
    name: fullName,
    'custom:usertype': userType,
    'custom:agreedtoterms': agreedToTerms.toString(),
  };
  try {
    const response = await Auth.signUp({ username, password, attributes });
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

const confirmSignUp = async (email, code) => {
  try {
    const response = await Auth.confirmSignUp(email, code, {
      forceAliasCreation: true,
    });
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

const signOut = async () => {
  try {
    const response = await Auth.signOut();
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

const checkAuth = async () => {
  try {
    const response = await Auth.currentAuthenticatedUser();
    const { attributes, signInUserSession } = response;
    return { attributes, jwtToken: signInUserSession.accessToken.jwtToken };
  } catch (error) {
    throw new Error(error.message);
  }
};

const forgotPassword = async (username) => {
  try {
    const response = await Auth.forgotPassword(username);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

const forgotPasswordSubmit = async (username, code, newPassword) => {
  try {
    const response = await Auth.forgotPasswordSubmit(
      username,
      code,
      newPassword,
    );
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

const resendSignUpCode = async (username) => {
  try {
    const response = await Auth.resendSignUp(username);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export {
  signIn,
  signOut,
  checkAuth,
  signUp,
  confirmSignUp,
  forgotPassword,
  forgotPasswordSubmit,
  resendSignUpCode,
};
